// extracted by mini-css-extract-plugin
module.exports = {"ourTakeWrapper":"our-take-highlight_ourTakeWrapper__OfdWA","banner":"our-take-highlight_banner__cyFdn"};